import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: 'faq_q1', a: 'faq_a1' },
    { q: 'faq_q2', a: 'faq_a2' },
    { q: 'faq_q3', a: 'faq_a3' },
    { q: 'faq_q4', a: 'faq_a4' },
    { q: 'faq_q5', a: 'faq_a5' },
  ];

  return (
    <section id="faq" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            {t('faq_title')}
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="font-medium text-foreground-900 pr-4">{t(faq.q)}</span>
                {openIndex === idx ? (
                  <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-primary-600 flex-shrink-0" />
                ) : (
                  <i className="ri-add-line w-5 h-5 flex items-center justify-center text-foreground-400 flex-shrink-0" />
                )}
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{t(faq.a)}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}